import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface MiniStoriesContainerEntityParams {
  name: string;
}
export class MiniStoriesContainerEntity extends BaseEntityClass {
  name: string;
  constructor(params: MiniStoriesContainerEntityParams) {
    super();
    this.type = "mini_stories_container";
    this.entity_version = 2;
    this.name = params.name;
  }
}
